import { render, staticRenderFns } from "./NrcProductAutocomplete.vue?vue&type=template&id=6b2e8d4a&"
import script from "./NrcProductAutocomplete.vue?vue&type=script&setup=true&lang=js&"
export * from "./NrcProductAutocomplete.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports